import React from "react";
import {
  FiTool,
  FiClock,
  FiCheckCircle,
  FiCalendar,
  FiX,
} from "react-icons/fi";

function ServiceRequestCard({ request }) {
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString();
  };

  const getStatusBadge = (status) => {
    const baseClasses = "px-2.5 py-0.5 rounded-full text-xs font-medium";

    switch (status) {
      case "Pending":
        return (
          <span className={`${baseClasses} bg-yellow-100 text-yellow-800`}>
            <div className="flex items-center gap-1">
              <FiClock className="w-3 h-3" />
              <span>Pending</span>
            </div>
          </span>
        );
      case "Scheduled":
        return (
          <span className={`${baseClasses} bg-blue-100 text-blue-800`}>
            <div className="flex items-center gap-1">
              <FiCalendar className="w-3 h-3" />
              <span>Scheduled</span>
            </div>
          </span>
        );
      case "In Progress":
        return (
          <span className={`${baseClasses} bg-purple-100 text-purple-800`}>
            <div className="flex items-center gap-1">
              <FiTool className="w-3 h-3" />
              <span>In Progress</span>
            </div>
          </span>
        );
      case "Completed":
        return (
          <span className={`${baseClasses} bg-green-100 text-green-800`}>
            <div className="flex items-center gap-1">
              <FiCheckCircle className="w-3 h-3" />
              <span>Completed</span>
            </div>
          </span>
        );
      case "Cancelled":
        return (
          <span className={`${baseClasses} bg-red-100 text-red-800`}>
            <div className="flex items-center gap-1">
              <FiX className="w-3 h-3" />
              <span>Cancelled</span>
            </div>
          </span>
        );
      default:
        return (
          <span className={`${baseClasses} bg-gray-100 text-gray-800`}>
            {status}
          </span>
        );
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-7 gap-2 p-4 hover:bg-gray-50 cursor-pointer">
      <div className="font-medium text-[#363062]">{request.identifier}</div>
      <div className="text-gray-700">{request.serviceType}</div>
      <div className="text-gray-700">{request.userName || "N/A"}</div>
      <div className="text-gray-600">{formatDate(request.createdAt)}</div>
      <div className="text-gray-700">{formatDate(request.preferredDate)}</div>
      <div className="text-gray-700">{request.preferredTime || "N/A"}</div>
      <div className="flex justify-center">
        {getStatusBadge(request.status)}
      </div>
    </div>
  );
}

export default ServiceRequestCard;
